<template>
  <div class="width">
    <div>
      <div class=" self-center  p-xl-12 p-ms-5">
        <div class=" p-jc-between p-grid">
          <p class=" font-bold mr-2 text-3xl "> Détails du projet :</p>
        </div>
        <Skeleton width="10rem" class="mb-2"></Skeleton>
        <div class="pt-5 mt-2 mb-4">
          <p class="subheading mr-2 text-2xl p-text-bold mb-2"> Description :</p>
          <Skeleton width="10rem" class="mb-2"></Skeleton>
        </div>
      </div>
      <div id="editing">
        <div id="files" class="w-full flex items-center shadow">
          <div class="tab-file tab-html px-8 py-2 cursor-pointer"
              :class="{ 'active': selectedTab === 'Utilisateurs' }">
            <span class="flex items-center">
              <span> <v-mdi name="mdi-account" id="icon-css" class="mr-2" height="18"
                            width="20"></v-mdi>
                Utilisateurs
              </span>
            </span>
          </div>
          <div class="tab-file tab-css px-8 py-2 cursor-pointer"
              :class="{ 'active': selectedTab === 'Groupes' }">
            <span class="flex items-center">
              <v-mdi name="mdi-account-multiple" id="icon-css" class="mr-2" height="18"
                    width="20"></v-mdi>
              Groupes
            </span>
          </div>
        </div>
      </div>
      <div class=" shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mt-5 mx-3">
        <DataTable class=" p-datatable-striped admin-projects-table"
                  :value="products" responsiveLayout="scroll">
          <Column field="Avatar" header="Avatar">
            <template #body>
              <Skeleton shape="circle" size="2rem" ></Skeleton>
            </template>
          </Column>
          <Column field="Nom" header="Nom">
            <template #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="Email" header="Email">
            <template #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
  components: {
    DataTable,
    Column,
  },
  data() {
    return {
      products: new Array(4),
      selectedTab: 'Utilisateurs'
    }
  }
}
</script>


<style scoped lang="scss">
#editing {
  #files {
    .tab-file {
      border-bottom: 2px solid transparent;
      color: var(--text-light);
      transition: all .3s;

      &.tab-html {
        #icon-html {
          color: #d45632;
        }

        &.active {
          border-color: #d45632;
        }
      }

      &.tab-css {
        #icon-css {
          color: #2652dc;
        }

        &.active {
          border-color: #2652dc;
        }
      }

      &.tab-js {
        #icon-js {
          color: #f0db4f;
        }

        &.active {
          border-color: #f0db4f;
        }
      }

      &.active {
        color: var(--text-white);
        background-color: var(--bg-input);
      }
    }
  }

  #code {
    .tab-code {
      display: none;

      &.active {
        display: block;
      }
    }
  }
}
</style>
